import actionCreatorFactory from "typescript-fsa";
import * as constants from "./constants";

const actionCreator = actionCreatorFactory("auth");

export const setNewToken = actionCreator.async<string, {}>(
  constants.constants.NEW_TOKEN
);

export const logOutAuth = actionCreator.async<boolean, {}>(
  constants.constants.LOGOUT
);
